export default "assets/images/marker-f145c27d.svg";